module.exports = __webpack_public_path__ + "static/img/page1.af08ea39.png";